(function ($) {
    function setMap(location) {
        const mapImg = document.querySelector("#map-wrap img");
        if (!mapImg)
            return;
        const basePath = "/wp-content/themes/meta-blueprint/assets/images/";
        let newSrc;
        switch (location) {
            case "auckland":
                newSrc = basePath + "auckland_map.png";
                break;
            case "canterbury":
                newSrc = basePath + "canterbury_map.png";
                break;
            case "wellington":
                newSrc = basePath + "wellington_map.png";
                break;
            case "central-north-island":
                newSrc = basePath + "central_north_map.png";
                break;
            case "otago":
                newSrc = basePath + "otago_map.png";
                break;
            case "south-canterbury":
                newSrc = basePath + "south_canterbury_map.png";
                break;
            case "southland":
                newSrc = basePath + "southland_map.png";
                break;
            case "taranaki":
                newSrc = basePath + "taranaki_map.png";
                break;
            case "wellington-hawkes-bay":
                newSrc = basePath + "wellington_map.png";
                break;
            default:
                newSrc = basePath + "auckland_map.png"; // fallback
                break;
        }
        mapImg.setAttribute("src", newSrc);
    }
    function handleFacetChange() {
        const selected = FWP.facets.centres || [];
        const mapWrap = document.getElementById("map-wrap");
        const resultsWrap = document.querySelector(".results-wrap");
        if (selected.length) {
            if (mapWrap) {
                mapWrap.classList.remove("hidden");
            }
            if (resultsWrap) {
                resultsWrap.classList.add("with-map");
            }
            setMap(selected[0]);
        }
        else {
            if (mapWrap) {
                mapWrap.classList.add("hidden");
            }
            if (resultsWrap) {
                resultsWrap.classList.remove("with-map");
            }
        }
    }
    // Fires on initial load AND after every facet refresh
    $(document).on("facetwp-loaded", function () {
        handleFacetChange();
    });
})(jQuery);
